export const CONTROL_PANEL = {
  limitSelect: 'Low — rake pl 50 on Poker Stars\n'
    + 'Mid — rake  pl 200 on Poker Stars\n'
    + 'High — rake pl 2000 on Poker Stars',
  stackSize: 'For cash games:\n'
    + '30 - 30 bb\n'
    + '50 - 50 bb\n'
    + '100 - 100 bb',
  position: 'Our starting position. Always\n highlighted in green',
  handType: 'Starting hand type selection',
};

export const TABLE = {
  fullCardBlock: 'EV actions in EV bb per hand\n (frequency of action)\n\n'
    + 'Indication of the correct action',
  choiceFutureActions: 'Move to the next hand or see the range\n with this hand.',
  modal: 'The left side of the cell is playing\n against the 3bet while in position\n postflop, the right side is out of\n position. Fully filled cell - no difference.',
  complete: 'Complete the tutorial and try playing.',
};
